export default __webpack_public_path__ + "static/media/logo_bg.76136bb5.png";